document.addEventListener("DOMContentLoaded", function () {
  const cutoff = document.getElementById("cutoffTime")?.value || "21:00:00";
  const deliveryDays = parseInt(document.getElementById("deliveryDays")?.value || "1");
  const offDays = (document.getElementById("offDays")?.value || "sunday").split(",");
  const container = document.getElementById("countdownMessage");

  function getDubaiTime() {
    return new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Dubai" }));
  }

  function getNextDeliveryDate(start, addDays) {
    const date = new Date(start);
    date.setDate(date.getDate() + addDays);
    while (offDays.includes(date.toLocaleString("en-GB", { weekday: "long" }).toLowerCase())) {
      date.setDate(date.getDate() + 1);
    }
    return date;
  }

  function updateCountdown() {
    const now = getDubaiTime();
    const [h, m, s] = cutoff.split(":").map(Number);

    const cutoffDate = getDubaiTime();
    cutoffDate.setHours(h, m, s, 0);
    if (now > cutoffDate) cutoffDate.setDate(cutoffDate.getDate() + 1);

    const diff = cutoffDate - now;
    const hrs = Math.floor(diff / 3.6e6);
    const mins = Math.floor((diff % 3.6e6) / 6e4);

    const delivery = getNextDeliveryDate(now, deliveryDays);
    const deliveryText = delivery.toLocaleDateString("en-GB", { day: "numeric", month: "long" });

    container.innerHTML = `<div>Order within <span>${hrs} Hrs ${mins} Mins</span> to receive ${deliveryText}</div>`;
  }

  updateCountdown();
  setInterval(updateCountdown, 60 * 1000);
});
